import { render, staticRenderFns } from "./agentManagements.vue?vue&type=template&id=0118b537"
import script from "./agentManagements.vue?vue&type=script&lang=js"
export * from "./agentManagements.vue?vue&type=script&lang=js"
import style0 from "./agentManagements.vue?vue&type=style&index=0&id=0118b537&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports